let allGalleries = document.querySelectorAll('.lightgallery-reviews');
allGalleries.forEach(item => lightGallery(item, {
	selector: '.vg-reviews-item'
}));